import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
  standalone: false,
})
export class DividerComponent {
  @Input() align: 'left' | 'center' | 'right' = 'center';
  @Input() class: '';
  @Input() text = '';
}
